<template>
    <MainContent>
        <template v-slot:header>
            <PageTitle title="Inventario"/>
        </template>
        <template v-slot:content>
            <div class="w-100">
                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Indumentarias vendidas por prenda y talla" :active="active == 'indumentarias_vendidas'" @click="setActive('indumentarias_vendidas')">
                            <Indumentarias  v-if="active == 'indumentarias_vendidas'" :ruta="'back.bases.indumentarias.inventario.vendidas'"/>
                        </b-tab>
                        <b-tab title="Stock disponible por prenda y talla" :active="active == 'stock_disponible'" @click="setActive('stock_disponible')">
                            <Indumentarias  v-if="active == 'stock_disponible'" :ruta="'back.bases.indumentarias.inventario.stock-disponible'"/>
                        </b-tab>
                        <b-tab title="Indumentarias recogidas y sin recoger" :active="active == 'indumentarias_recogidas'" @click="setActive('indumentarias_recogidas')">
                            <IndumentariasRecogidas v-if="active == 'indumentarias_recogidas'" />
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import PageTitle from '@/components/backend/components/PageTitleComponent';
    import Indumentarias from '@/components/backend/bases/indumentarias/inventario/Indumentarias';
    import IndumentariasRecogidas from '@/components/backend/bases/indumentarias/inventario/IndumentariasRecogidas';

    export default {
        data() {
            return {
                active: 'indumentarias_vendidas'
            }
        },
        methods: {
            setActive(data) {
                this.active = data;
            }
        },
        components: {
            MainContent, PageTitle, Indumentarias, IndumentariasRecogidas
        }
    }
</script>